import React from 'react';
import { string, bool, func, node, oneOfType, arrayOf } from 'prop-types';

import { Container } from 'components/buttons/ButtonStyles';

const Button = ({
  as,
  bg,
  borderColor,
  boxShadow,
  children,
  className,
  disabled,
  hoverBg,
  hoverBorderColor,
  hoverTextColor,
  href,
  margin,
  onClick,
  rel,
  size,
  target,
  textColor,
  width,
}) => (
  <Container
    as={as}
    bg={bg}
    borderColor={borderColor}
    boxShadow={boxShadow}
    className={className}
    disabled={disabled}
    hoverBg={hoverBg}
    hoverBorderColor={hoverBorderColor}
    hoverTextColor={hoverTextColor}
    href={href}
    margin={margin}
    onClick={onClick}
    rel={rel}
    size={size}
    target={target}
    textColor={textColor}
    width={width}
  >
    {children}
  </Container>
);

Button.defaultProps = {
  as: null,
  bg: null,
  borderColor: null,
  boxShadow: null,
  className: null,
  disabled: null,
  hoverBg: null,
  hoverBorderColor: null,
  hoverTextColor: null,
  href: null,
  margin: null,
  onClick: null,
  rel: null,
  size: null,
  target: null,
  textColor: null,
  width: null,
};

Button.propTypes = {
  as: string,
  bg: func,
  borderColor: string,
  boxShadow: func,
  children: oneOfType([arrayOf(node), node]).isRequired,
  className: string,
  disabled: bool,
  hoverBg: func,
  hoverBorderColor: string,
  hoverTextColor: string,
  href: string,
  margin: string,
  onClick: func,
  rel: string,
  size: string,
  target: string,
  textColor: func,
  width: string,
};

export default Button;
